import React from "react";
import { useTranslation } from "react-i18next";
import StatisticsBox from "./StatisticsBox";

const SchoolStatistics = ({ schoolName }) => {
  const { t } = useTranslation("sateliteSchools");

  return (
    <div className="statistics-container">
      <StatisticsBox 
        content={t(`${schoolName} childrens`)}
      />
      <StatisticsBox 
        content={t(`${schoolName} classes`)}
      />
      <StatisticsBox 
        content={t(`${schoolName} staff`)}
      />
    </div>
  );
};

export default SchoolStatistics;
